module.exports = __webpack_public_path__ + "img/salvavidas-texto.4c212d0a.png";